// src/jira/project-overview/types.ts
var JiraProjectOverviewAriResourceOwner = "jira", JiraProjectOverviewAriResourceType = "project-overview";

export {
  JiraProjectOverviewAriResourceOwner,
  JiraProjectOverviewAriResourceType
};
